import {
    setValidated,
    setInvalid,
    setInputFieldErrorMsg,
    setMessageError,
    setMessageWarning,
    addLoadingSpinnerOnInput,
    removeLoadingSpinnerOnInput,
    getInputsByType,
    getInputFieldsByType,
} from './sef-checkout-functions';

let timer;

document.addEventListener("DOMContentLoaded", () => {
    const inputType = localStorage.getItem('sef-shippingType') ?? 'billing';
    const inputs = getInputsByType(inputType);

    localStorage.setItem('sef-' + inputType + '-prevPostcode', inputs?.postcodeInput?.value ?? '');
    localStorage.setItem('sef-' + inputType + '-location', inputs?.cityInput?.value ?? '');
});

export function onInputPostcode(type) {
    clearTimeout(timer);

    localStorage.setItem('sef-shippingType', type);

    let changedPostcode = handleCityOnPostcodeInput();

    if (changedPostcode) {
        setPostcodeLoading(true);

        timer = setTimeout(sendPostcodeRequest, 750);
        // setTimeout(setPostcodeLoading(true), 500);

        // timer = setTimeout(sendPostcodeRequest, 750);
    }
}

/**
 * Send request for postcode.
 * 
 * Check if postcode exists.
 * Check if posten can ship to postcode.
 * Check if dsv can ship to postcode.
 */
export async function sendPostcodeRequest() {
    return new Promise((resolve, reject) => {
        const inputType = localStorage.getItem('sef-shippingType');
        const inputs = getInputsByType(inputType);

        const fields = getInputFieldsByType(inputType);

        const postcodeInput = inputs.postcodeInput;
        const postcodeField = fields.postcodeField;

        const cityInput = inputs.cityInput;
        const cityField = fields.cityField;

        if (!postcodeInput) {
            reject('Postcode input does not exist');
            return;
        }

        const postcode = postcodeInput.value;

        if (postcode.length != 4) {
            let prevPostcodeLength = localStorage.getItem('sef-' + inputType + '-prevPostcodeLength');

            setInvalid(postcodeField);
            localStorage.setItem('sef-' + inputType + '-validation', 'error');

            removePostcodeErrorWarning();

            if (prevPostcodeLength == 4) {
                updatePrice(inputType);
            }

            localStorage.setItem('sef-' + inputType + '-prevPostcodeLength', 0);

            return;
        }

        jQuery.ajax({
            url: sef_validate_checkout_postcode.ajax_url,
            type: "post",

            data: {
                _ajax_nonce: sef_validate_checkout_postcode.nonce,
                action: "sef_postcodeExist",
                postcode,
            },

        }).done(function (response) {
            // Creates a variable to check which validation to use.
            let validation = '';

            // Creates a variable to check if location should be validated.
            let location = '';

            try {
                if (postcode === '') {
                    validation = 'error';

                    throw '';
                }

                if ('exist' in response && !response.exist) {
                    validation = 'error';

                    throw 'postcode not exist';
                }

                if ('weight' in response && !response.weight) {
                    validation = 'warning';
                    location = response.location;

                    throw 'too heavy for posten';
                }

                if ('price' in response && !response.price) {
                    validation = 'warning';

                    throw 'no dsv';
                }

                removePostcodeErrorWarning();

                location = response.location;

                setValidated(cityField);
                setValidated(postcodeField);

            } catch (error) {
                localStorage.setItem('sef-' + inputType + '-validation', validation);
                validatePostcode(error);
            }

            localStorage.setItem('sef-' + inputType + '-validation', validation);
            localStorage.setItem('sef-' + inputType + '-location', location);

        }).always(function (response) {
            if ('location' in response) {
                cityInput.setAttribute('value', response.location);
                cityInput.value = response.location;
            }

            setPostcodeLoading(false);

            updatePrice(inputType);

            resolve(true);
        });
    });
}

/**
 * Handles error on postcode.
 * 
 * @param {Object | boolean} errorMsg 
 */
export function setPostcodeError(errorMsg) {
    const inputType = localStorage.getItem('sef-shippingType');

    const inputs = getInputsByType(inputType);
    const fields = getInputFieldsByType(inputType);

    const postcodeField = fields.postcodeField;
    const cityInput = inputs.cityInput;
    const cityField = fields.cityField;

    setInvalid(postcodeField);
    setMessageError(errorMsg);

    cityInput.setAttribute('value', '');
    cityInput.value = '';
    setInvalid(cityField);
}

/**
 * Handles warning on postcode
 * 
 * @param {Object} errorMsg 
 */
export function setPostcodeWarning(errorMsg) {
    const inputType = localStorage.getItem('sef-shippingType');

    const fields = getInputFieldsByType(inputType);

    const postcodeField = fields.postcodeField;
    const cityField = fields.cityField;

    setValidated(postcodeField);
    setValidated(cityField);

    setMessageWarning(errorMsg);
}

export function removePostcodeErrorWarning() {
    errorMsg = document.getElementById('sef-checkout-billing_postcode_field-error-message');

    if (errorMsg != null) {
        errorMsg.remove();
    }
}

/**
 * Set validation on postcode error message
 * 
 * @param {Object | boolean} errorMsg 
 */
export function setPostcodeValidation(errorMsg) {
    const inputType = localStorage.getItem('sef-shippingType');
    let validation = localStorage.getItem('sef-' + inputType + '-validation') ?? '';

    if (validation === 'error') {
        setPostcodeError(errorMsg);
    }

    if (validation === 'warning') {
        setPostcodeWarning(errorMsg);
    }
}

/**
 * Validate postcode input
 * 
 * @param {string} error 
 */
export function validatePostcode(error) {
    const inputType = localStorage.getItem('sef-shippingType');
    const inputs = getInputsByType(inputType);

    const fields = getInputFieldsByType(inputType);

    const postcodeInput = inputs.postcodeInput;
    const postcodeField = fields.postcodeField;

    let errorText = '';

    if (error === 'postcode not exist') {
        errorText = sef_validate_checkout_postcode.postCodeNotFound;
    }

    if (error === 'too heavy for posten') {
        errorText = sef_validate_checkout_postcode.postTooHeavy;
    }

    if (error === 'no dsv') {
        errorText = sef_validate_checkout_postcode.dsvNoShipping;
    }

    errorMsg = setInputFieldErrorMsg(errorText, postcodeField, postcodeInput);

    setPostcodeValidation(errorMsg);
}

/**
 * Set/remove loading spinner on postcode field
 * 
 * @param {boolean} value
 * @returns {void}
 */
export function setPostcodeLoading(value) {
    const inputType = localStorage.getItem('sef-shippingType');

    const inputs = getInputsByType(inputType);
    const fields = getInputFieldsByType(inputType);

    const cityInput = inputs.cityInput;
    const postcodeField = fields.postcodeField;

    const postcodeInput = inputs.postcodeInput;

    if (!value || postcodeInput.value.length != 4) {
        removeLoadingSpinnerOnInput(postcodeField);

        cityInput.removeAttribute('disabled');

        return;
    }

    addLoadingSpinnerOnInput(postcodeField);

    cityInput.setAttribute('disabled', 'disabled');
}

/**
 * Empty city input
 */
export function handleCityOnPostcodeInput() {
    const inputType = localStorage.getItem('sef-shippingType');

    const inputs = getInputsByType(inputType);
    const fields = getInputFieldsByType(inputType);

    const postcodeInput = inputs.postcodeInput;
    const cityInput = inputs.cityInput;

    const cityField = fields.cityField;

    let prevPostcode = localStorage.getItem('sef-' + inputType + '-prevPostcode');

    if (prevPostcode === postcodeInput.value) {
        let postcodeLocation = localStorage.getItem('sef-' + inputType + '-location');

        if (cityInput.value === '') {
            cityInput.setAttribute('value', postcodeLocation);
            cityInput.value = postcodeLocation;
            setValidated(cityField);
        }

        return false;
    }

    if (prevPostcode.length == 4) {
        localStorage.setItem('sef-' + inputType + '-prevPostcodeLength', prevPostcode.length);
    }

    if (cityInput.value != '') {
        cityInput.setAttribute('value', '');
        cityInput.value = '';
        setInvalid(cityField);
    }

    localStorage.setItem('sef-' + inputType + '-prevPostcode', postcodeInput.value);

    return true;
}

/**
 * Update price on checkout page
 */
export function updatePrice(type) {
    const shipping = document.getElementById('ship-to-different-address-checkbox');

    if (shipping) {
        if (shipping.checked && type != 'shipping') {
            return;
        }
    }

    const inputs = getInputsByType(type);

    const postcodeInput = inputs.postcodeInput;
    const cityInput = inputs.cityInput;

    // Update price if both inputs are empty
    if (postcodeInput.value != '' && cityInput.value != '') {
        jQuery(document.body).trigger("update_checkout");
    }

    // Update price if both inputs are filled
    if (postcodeInput.value === '' && cityInput.value === '') {
        jQuery(document.body).trigger("update_checkout");
    }

    // Update price if postcode input is filled but city input is empty
    if (postcodeInput.value != '' && cityInput.value === '') {
        jQuery(document.body).trigger("update_checkout");
    }
}
